(function () {
  'use strict';
  if (window.__bhCollectionToolbar) return;
  window.__bhCollectionToolbar = true;

  var EN = /^en\b/i.test(document.documentElement.lang || '');
  var WANTED = ['manual', 'best-selling', 'created-descending', 'price-ascending', 'price-descending'];
  var LABELS = EN
    ? { manual: 'Featured', 'best-selling': 'Best selling', 'created-descending': 'Newest', 'price-ascending': 'Price: low to high', 'price-descending': 'Price: high to low', sort: 'Sort', close: 'Close', clear: 'Clear sorting' }
    : { manual: 'المميّز', 'best-selling': 'الأكثر مبيعاً', 'created-descending': 'الأحدث', 'price-ascending': 'السعر: من الأقل', 'price-descending': 'السعر: من الأعلى', sort: 'ترتيب', close: 'إغلاق', clear: 'إلغاء الترتيب' };

  var ICON_SORT = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 4v12M6 16l-3-3M6 16l3-3M14 16V4M14 4l-3 3M14 4l3 3"/></svg>';

  function currentSort(container) {
    var fromUrl = new URLSearchParams(window.location.search).get('sort_by');
    if (fromUrl) return fromUrl;
    var select = container.querySelector('select[name="sort_by"]');
    return (select && select.value) || 'manual';
  }

  function build(container) {
    if (container.querySelector('.bh-toolbar__sort')) return;
    var select = container.querySelector('select[name="sort_by"]');
    if (!select) return;
    var available = Array.prototype.map.call(select.options, function (o) { return o.value; });
    var options = WANTED.filter(function (v) { return available.indexOf(v) !== -1; });
    if (!options.length) return;
    var active = currentSort(container);

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'bh-toolbar__sort';
    pill.setAttribute('aria-haspopup', 'dialog');
    pill.setAttribute('aria-expanded', 'false');
    pill.innerHTML = ICON_SORT + '<span class="bh-toolbar__sort-label">' + LABELS.sort + '</span>' +
      (active !== 'manual' && LABELS[active] ? '<span class="bh-toolbar__sort-value">' + LABELS[active] + '</span>' : '');

    var sheet = document.createElement('div');
    sheet.className = 'bh-sort-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="bh-sort-sheet__backdrop" data-bh-sort-close></div>' +
      '<div class="bh-sort-sheet__panel" role="dialog" aria-modal="true" aria-label="' + LABELS.sort + '">' +
        '<div class="bh-sort-sheet__head"><strong>' + LABELS.sort + '</strong>' +
          '<button type="button" class="bh-sort-sheet__close" data-bh-sort-close aria-label="' + LABELS.close + '">×</button></div>' +
        '<div class="bh-sort-sheet__list" role="radiogroup">' +
          options.map(function (v) {
            return '<button type="button" role="radio" class="bh-sort-sheet__item' + (v === active ? ' is-active' : '') + '" aria-checked="' + (v === active) + '" data-bh-sort="' + v + '">' +
              '<span>' + LABELS[v] + '</span><span class="bh-sort-sheet__check" aria-hidden="true"></span></button>';
          }).join('') +
        '</div>' +
      '</div>';

    function close() { sheet.hidden = true; pill.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('bh-sort-open'); pill.focus(); }
    function open() { sheet.hidden = false; pill.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('bh-sort-open'); var a = sheet.querySelector('.is-active') || sheet.querySelector('[data-bh-sort]'); if (a) a.focus(); }

    pill.addEventListener('click', function () { if (sheet.hidden) open(); else close(); });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-bh-sort-close]')) { close(); return; }
      var item = e.target.closest('[data-bh-sort]');
      if (!item) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', item.getAttribute('data-bh-sort'));
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });

    var wrapper = container.querySelector('.mobile-facets__wrapper');
    container.insertBefore(pill, wrapper || container.firstChild);
    if (active !== 'manual' && LABELS[active]) {
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'bh-toolbar__sort-clear';
      clear.setAttribute('aria-label', LABELS.clear);
      clear.title = LABELS.clear;
      clear.textContent = '×';
      clear.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
      pill.insertAdjacentElement('afterend', clear);
    }
    document.body.appendChild(sheet);
  }

  function keepGroupsOpen(container) {
    var groups = container.querySelectorAll('details.mobile-facets__details');
    for (var i = 0; i < groups.length; i++) {
      groups[i].open = true;
      var summary = groups[i].querySelector('summary');
      if (summary && !summary.__bhLocked) {
        summary.__bhLocked = true;
        summary.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); }, true);
        summary.setAttribute('tabindex', '-1');
      }
    }
  }

  var NAMES = { Availability: 'التوفر', Price: 'السعر', 'Product type': 'نوع المنتج', Color: 'اللون', Size: 'المقاس' };
  function arabicNames(container) {
    if (EN) return;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (!text || text.length > 60) continue;
      var m = text.match(/^(\s*)(Availability|Price|Product type|Color|Size)(\s*:?\s*)/);
      if (m) node.nodeValue = m[1] + NAMES[m[2]] + m[3] + text.slice(m[0].length); // characterData only: not observed below
    }
  }

  function closeButton(container) {
    var header = container.querySelector('.mobile-facets__header');
    var summary = container.querySelector('.mobile-facets__open-wrapper');
    if (!header || !summary || header.querySelector('.bh-filter-close')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bh-filter-close';
    b.setAttribute('aria-label', LABELS.close);
    b.textContent = '×';
    b.addEventListener('click', function () { summary.click(); });
    header.appendChild(b);
  }

  function init() {
    var container = document.querySelector('.facets-container-drawer');
    if (!container) return;
    document.documentElement.classList.add('bh-has-toolbar');
    build(container);
    closeButton(container);
    keepGroupsOpen(container);
    arabicNames(container);
    var main = container.querySelector('.mobile-facets__main');
    if (main && window.MutationObserver) {
      new MutationObserver(function () { keepGroupsOpen(container); arabicNames(container); }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
